import { ProductSearchResults } from './ProductSearchResults';
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
export var ProductSeachComponent = function () { return /*#__PURE__*/ _jsx(_Fragment, { children: /*#__PURE__*/ _jsx(ProductSearchResults, {}) }); };
